import { LinkGeometryActionTypes, AddLinkGeometries, ModifyLinkGeometries, DeleteLinkGeometries } from 'Actions/ActionTypes/index';
import { LinkGeometry, Id } from 'NSwag/ServerClient/Client.nswag';

/**
 * Defines methods that create action objects for Link Geometries
 * in the store
 */

export const addLinkGeometries = (linkGeometries: LinkGeometry[]): AddLinkGeometries => ({
    type: LinkGeometryActionTypes.AddGeometries as LinkGeometryActionTypes.AddGeometries,
    linkGeometries
});

export const modifyLinkGeometries = (linkGeometries: LinkGeometry[] ): ModifyLinkGeometries => ({
    type: LinkGeometryActionTypes.ModifyGeometries as LinkGeometryActionTypes.ModifyGeometries,
    linkGeometries
});

export const deleteLinkGeometries = (ids: Id[]): DeleteLinkGeometries => ({
    type: LinkGeometryActionTypes.DeleteGeometries as LinkGeometryActionTypes.DeleteGeometries,
    ids
});

export type LinkGeometryAction = ReturnType<typeof addLinkGeometries | typeof modifyLinkGeometries | typeof deleteLinkGeometries>